import React, { useState, useEffect, useContext } from 'react';
import { Skeleton, Box, useMediaQuery, useTheme, CircularProgress } from '@mui/material';
import ImageCacheContext from './image-cache-context';
import ImageIcon from '@mui/icons-material/Image';

function HandoutImageLoader({ src, alt, imageStore, ...props }) {
  const [loadedSrc, setLoadedSrc] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // Add isLoading state
  const recentlyCachedUrls = useContext(ImageCacheContext);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    async function loadImage() {
      console.log(`HandoutImageLoader loadImage: ${src}`);

      const imageObject = await imageStore.getImageFromIndexedDB(src);

      if (imageObject && imageObject.data) {
        console.log(`HandoutImageLoader loadImage: ${src} found in IndexedDB`);
        setLoadedSrc(imageObject.data);
      }

      setIsLoading(false); // Set loading state to false when image is loaded
    }

    loadImage();
  }, [src, imageStore, recentlyCachedUrls]);

  if (isLoading) { // Display a loading skeleton while image is loading
    return (
      <Box position="relative" display="inline-block" width={isMobile ? "100%" : 210} height={118}>
        <Skeleton variant="rectangular" width="100%" height="100%" />
        <Box
          position="absolute"
          top="50%"
          left="50%"
          style={{ transform: "translate(-50%, -50%)" }}
        >
          <ImageIcon fontSize="large" color="disabled" />
        </Box>
      </Box>
    );
  }

  if (!loadedSrc) { // Display placeholder if image is not found
    return <CircularProgress />;
  }

  return (
    <img
      src={loadedSrc}
      alt={alt}
      style={isMobile ? { width: '100%', height: 'auto' } : { maxWidth: '100%', height: 'auto' }}
      {...props}
    />
  );
}

export default HandoutImageLoader;
